import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-invalid-permissions',
  templateUrl: './invalid-permissions.component.html',
  styleUrls: ['./invalid-permissions.component.scss']
})
export class InvalidPermissionsComponent {
 errorMessage: string | null = "";

  constructor(
    private aRoute: ActivatedRoute,
  ) {}

  ngOnInit() {

    this.aRoute.parent!.paramMap.subscribe(params => {
      this.errorMessage = params.get('error');
      console.log(this.errorMessage);
    });
  }    

  isError(): boolean {
    return (this.errorMessage) ? true : false;
  }

 }
